// Chat Storm: Rota "Conta" (settings/general / general_settings_index) removida.
// O item nao tem mais uso no Chat Storm. O redirect padrao de "Settings" para
// administradores foi ajustado em settings.routes.js para conversation_workflow_index.
export default {
  routes: [],
};
